import type { ReactNode } from 'react'
import { NavLink } from 'react-router-dom'

type Props = {
  to: string
  end?: boolean | undefined
  onNavigate?: (() => void) | undefined
  onPrefetch?: (() => void) | undefined
  children: ReactNode
}

export function SidebarNavLink({ to, end, onNavigate, onPrefetch, children }: Props) {
  return (
    <NavLink
      to={to}
      {...(end !== undefined ? { end } : {})}
      {...(onNavigate ? { onClick: onNavigate } : {})}
      {...(onPrefetch ? { onMouseEnter: onPrefetch, onFocus: onPrefetch } : {})}
      className={({ isActive }) =>
        `flex items-center gap-2 rounded-md px-2 py-1.5 text-[13px] font-medium transition-colors ${
          isActive
            ? 'bg-accent text-accent-foreground'
            : 'text-muted-foreground hover:bg-muted hover:text-foreground'
        }`
      }
    >
      {children}
    </NavLink>
  )
}
